import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["onClickRequestChanges", "approvalType", "disabledReason"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Button } from 'foundations-components/transitional/components/Button';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { APPROVAL_REQUEST_CHANGES } from '../../constants/trackingConstants';
import { trackInteraction } from '../../utils/usageTracker.ts';
import { useApprovalContext } from '../../hooks/useApprovalContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const LegacyRequestChangesCommentButton = _ref => {
  let {
      onClickRequestChanges,
      approvalType: approvalTypeProp,
      disabledReason
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    data,
    meta
  } = useApprovalContext();
  const approvalType = approvalTypeProp !== null && approvalTypeProp !== void 0 ? approvalTypeProp : meta.approvalType;
  const onClickRequestChangesButton = () => {
    onClickRequestChanges();
    trackInteraction(APPROVAL_REQUEST_CHANGES, approvalType, {
      approvalId: data === null || data === void 0 ? void 0 : data.id
    });
  };
  return /*#__PURE__*/_jsx(Tooltip, {
    title: disabledReason !== null && disabledReason !== void 0 ? disabledReason : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.noAccessTooltip"
    }),
    disabled: !buttonProps.disabled,
    children: /*#__PURE__*/_jsx(Button, Object.assign({
      use: "tertiary-light"
    }, buttonProps, {
      onClick: onClickRequestChangesButton,
      disabled: buttonProps.disabled,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.LegacyRequestChangesCommentButton.text"
      })
    }))
  });
};